import React from 'react';
import { Box } from '@mui/material';
import Hero from './components/Hero';
import Features from './components/Features';
import Accommodations from './components/Accommodations';
import SiteFooter from './components/SiteFooter';

const HomePage = () => (
  <Box sx={{ minHeight: '100vh', backgroundColor: '#fafafa' }}>
    <Hero id="hero" />
    <Features id="features" />
    <Accommodations id="accommodations" />
    <SiteFooter />
  </Box>
);

export default HomePage;
